import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonGroup, Divider, IconButton, Typography } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { RadioGroupUi } from "../../../../components/uiElements/radioGroup/RadioGroupUi";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useEffect } from "react";
import { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ClearIcon from "@mui/icons-material/Clear";
import { gridFilterModelSelector, useGridSelector } from "@mui/x-data-grid-pro";


export const TextFiltersOptions = ({ applyFilter, vals }) => {
  return (
    <Box sx={{ padding: "5px 0px 0px 15px" }}>
      <RadioGroupUi
        onChange={(e) => {
          e.stopPropagation();
          const newOperator = e.target.value;
          
          // When operator changes, reset value appropriately
          let newValue = vals.value;
          if (["isNotEmpty", "isEmpty"].includes(newOperator)) {
            newValue = ""; // No value needed for these
          }

          applyFilter({
            ...vals,
            operatorValue: newOperator,
            value: newValue,
          });
        }}
        value={vals.operatorValue || "contains"}
        onTextFieldChange={(e) => {
          e.stopPropagation();
          // Only update value, keep operator
          applyFilter({
            ...vals,
            value: e.target.value,
          });
        }}
        textFieldVal={vals.value || ""}
        name="text-filter"
        options={[
          { name: "is not empty", value: "isNotEmpty" },
          { name: "contains", value: "contains", inputField: true, inputFieldType: "text" },
          { name: "is empty", value: "isEmpty" },
        ]}
      />
    </Box>
  );
};

// ✅ PhoneFiltersOptions - FIXED to preserve state
export const PhoneFiltersOptions = ({ applyFilter, vals }) => {
  return (
    <Box sx={{ padding: "5px 0px 0px 15px" }}>
      <RadioGroupUi
        onChange={(e) => {
          e.stopPropagation();
          const newOperator = e.target.value;

          // When operator changes, reset value appropriately
          let newValue = vals.value;
          if (["isGood", "isNotEmpty", "isEmpty", "isBad"].includes(newOperator)) {
            newValue = ""; // No value needed for these
          }

          applyFilter({
            ...vals,
            operatorValue: newOperator,
            value: newValue,
          });
        }}
        value={vals.operatorValue || "isGood"}
        onTextFieldChange={(e) => {
          e.stopPropagation();
          applyFilter({
            ...vals,
            value: e.target.value,
          });
        }}
        textFieldVal={vals.value || ""}
        name="phone-filter"
        options={[
          { name: "is good", value: "isGood" },
          { name: "starts with", value: "startsWith", inputField: true, inputFieldType: "number" },
          { name: "does not starts with", value: "notStartsWith", inputField: true, inputFieldType: "number" },
          { name: "is not empty", value: "isNotEmpty" },
          { name: "is empty", value: "isEmpty" },
          { name: "is bad", value: "isBad" },
        ]}
      />
    </Box>
  );
};

// ✅ PriceFiltersOptions - FIXED to preserve state
export const PriceFiltersOptions = ({ applyFilter, vals }) => {
  return (
    <Box sx={{ padding: "5px 0px 0px 15px" }}>
      <RadioGroupUi
        onChange={(e) => {
          e.stopPropagation();
          const newOperator = e.target.value;

          let newValue = vals.value;
          if (newOperator === "<>") {
            newValue = { start: "", end: "" };
          } else if (["isNotEmpty", "isEmpty"].includes(newOperator)) {
            newValue = "";
          }

          applyFilter({
            ...vals,
            operatorValue: newOperator,
            value: newValue,
          });
        }}
        value={vals.operatorValue || "isNotEmpty"}
        onTextFieldChange={(e, val) => {
          e.stopPropagation();
          applyFilter({
            ...vals,
            value: val,
          });
        }}
        textFieldVal={vals.value || ""}
        name="price-filter"
        options={[
          { name: "is not empty", value: "isNotEmpty" },
          { name: "is less than", value: "<", inputField: true, inputFieldType: "number" },
          { name: "is greater than", value: ">", inputField: true, inputFieldType: "number" },
          { name: "is between", value: "<>", int_between: true, inputFieldType: "number" },
          { name: "is empty", value: "isEmpty" },
        ]}
      />
    </Box>
  );
};

// ✅ DateFiltersOptions - FIXED to preserve state
export const DateFiltersOptions = ({ applyFilter, vals }) => {
  return (
    <Box sx={{ padding: "5px 0px 0px 15px" }}>
      <RadioGroupUi
        onChange={(e) => {
          e.stopPropagation();
          const newOperator = e.target.value;

          let newValue = vals.value;
          if (newOperator === "<>") {
            newValue = {
              start: { timeInterval: "days", value: "" },
              end: { timeInterval: "days", value: "" },
            };
          } else if (newOperator === "isEmpty") {
            newValue = { timeInterval: "days", value: "" };
          } else {
            newValue = { timeInterval: "days", value: "" };
          }

          applyFilter({
            ...vals,
            operatorValue: newOperator,
            value: newValue,
          });
        }}
        value={vals.operatorValue || "<"}
        onTextFieldChange={(e, valField) => {
          e.stopPropagation();

          if (vals.operatorValue === "<>") {
            const fieldName = valField === "start" ? "start" : "end";
            applyFilter({
              ...vals,
              value: {
                ...vals.value,
                [fieldName]: {
                  timeInterval: vals.value?.[fieldName]?.timeInterval || "days",
                  value: e.target.value,
                },
              },
            });
          } else {
            applyFilter({
              ...vals,
              value: {
                ...vals.value,
                value: e.target.value,
              },
            });
          }
        }}
        onDropDownSelectFieldChange={(e, valField) => {
          e.stopPropagation();

          if (vals.operatorValue === "<>") {
            const fieldName = valField === "start" ? "start" : "end";
            applyFilter({
              ...vals,
              value: {
                ...vals.value,
                [fieldName]: {
                  timeInterval: e.target.value || "days",
                  value: vals.value?.[fieldName]?.value || "",
                },
              },
            });
          } else {
            applyFilter({
              ...vals,
              value: {
                ...vals.value,
                timeInterval: e.target.value,
              },
            });
          }
        }}
        textFieldVal={vals.value}
        name="date-filter"
        options={[
          { name: "was less than", value: "<", inputDateTimeFrame: true, inputFieldType: "number" },
          { name: "was greater than", value: ">", inputDateTimeFrame: true, inputFieldType: "number" },
          { name: "between", value: "<>", inputDateTimeFrame: true, inputFieldType: "number" },
          { name: "are empty", value: "isEmpty" },
        ]}
      />
    </Box>
  );
};

// ✅ IncludeWithEmptyFiltersOptions - FIXED to preserve state
export const IncludeWithEmptyFiltersOptions = ({ applyFilter, vals, data }) => {
  return (
    <Box sx={{ padding: "5px 0px 0px 15px" }}>
      <RadioGroupUi
        onChange={(e) => {
          e.stopPropagation();
          const newOperator = e.target.value;

          let newValue = vals.value;
          if (["isNotEmpty", "isEmpty"].includes(newOperator)) {
            newValue = "";
          }

          applyFilter({
            ...vals,
            operatorValue: newOperator,
            value: newValue,
          });
        }}
        value={vals.operatorValue || "isNotEmpty"}
        textField={"name"}
        onDropDownSelectFieldChange={(e, val) => {
          e.stopPropagation();
          applyFilter({
            ...vals,
            value: val,
          });
        }}
        dropDownVal={vals.value || ""}
        name="include-exclude-empty-filter"
        dataList={data}
        options={[
          { name: "are not empty", value: "isNotEmpty" },
          { name: "include any", value: "isAnyOf", multiDrop: true },
          { name: "exclude any", value: "not", multiDrop: true },
          { name: "are empty", value: "isEmpty" },
        ]}
      />
    </Box>
  );
};

// ✅ IncludeWithoutEmptyFiltersOptions - FIXED to preserve state
export const IncludeWithoutEmptyFiltersOptions = ({ applyFilter, vals, data }) => {
  return (
    <Box sx={{ padding: "5px 0px 0px 15px" }}>
      <RadioGroupUi
        onChange={(e) => {
          e.stopPropagation();
          applyFilter({
            ...vals,
            operatorValue: e.target.value,
          });
        }}
        value={vals.operatorValue || "include"}
        textField={"name"}
        dropDownVal={vals.value || ""}
        onDropDownSelectFieldChange={(e, val) => {
          e.stopPropagation();
          applyFilter({
            ...vals,
            value: val,
          });
        }}
        name="include-exclude-filter"
        dataList={data}
        options={[
          { name: "include", value: "include", multiDrop: true },
          { name: "exclude", value: "exclude", multiDrop: true },
        ]}
      />
    </Box>
  );
};

const SortableContent = ({ field, apiRef, type }) => {
  const applySort = (direction) => {
    try {
      apiRef.current.setSortModel([
        {
          field: field,
          sort: direction,
        },
      ]);
    } catch (error) {
      console.log("error in sort", error);
    }
  };
  return (
    <Box sx={{ padding: "5px 0px 0px 15px", width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <SortIcon sx={{ marginRight: "5px" }} />
        <Typography variant="subtitle1" fontSize={14}>
          Sort
        </Typography>
      </Box>

      <Box>
        <ButtonGroup size="small" variant="outlined" aria-label="sort-buttons">
          <Button variant="outlined" onClick={(e) => applySort("asc")}>
            {type == "price" ? "0-9" : type === "date" ? "OLD TO NEW" : "A TO Z"}
          </Button>
          <Button variant="outlined" onClick={(e) => applySort("desc")}>
            {type == "price" ? "9-0" : type === "date" ? "NEW TO OLD" : "Z TO A"}
          </Button>
        </ButtonGroup>
      </Box>
    </Box>
  );
};

export const getDefaultOperator = (columnType) => {
  switch (columnType) {
    case "phone":
      return "isGood";
    case "date":
      return "<";
    case "price":
      return "isNotEmpty";
    case "include/exclude":
      return "include";
    case "include/exclude/empty":
      return "isNotEmpty";
    case "text":
    default:
      return "contains";
  }
};

export const LeadsCustomFilters = ({
  apiRef,
  tagsList,
  filterButtonEl,
  setFilterButtonEl,
  onFilterModelChange,
}) => {
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const items = filterModel.items || [];
  const columns = apiRef.current.state.columns.lookup;

  const [field, setField] = useState(
    apiRef.current.state?.focus?.columnHeader?.field ||
      apiRef.current.state?.tabIndex?.columnHeader?.field
  );
  const [expanded, setExpanded] = useState(null);
  const [localItems, setLocalItems] = useState(items);
  const [isUserInteracting, setIsUserInteracting] = useState(false);

  // Sync local items with filter model
  useEffect(() => {
    setLocalItems(items);
  }, [JSON.stringify(items)]);

  // Track focused column
  useEffect(() => {
    const unsubscribe = apiRef.current.subscribeEvent(
      "columnHeaderFocus",
      (params) => {
        setField(params.field);
        setExpanded(null);
      }
    );
    return () => unsubscribe();
  }, [apiRef]);

  const normalizeItem = (it) => ({
    id: it.id ?? `${it.columnField || it.field}_${Date.now()}`,
    columnField: it.columnField || it.field,
    field: it.field || it.columnField,
    operatorValue: it.operatorValue || it.operator || "contains",
    operator: it.operator || it.operatorValue || "contains",
    value: it.value ?? "",
  });

  const setItems = (newItems) => {
    setLocalItems(newItems);
    const newModel = { ...filterModel, items: newItems };

    if (typeof onFilterModelChange === "function") {
      onFilterModelChange(newModel);
    }

    try {
      apiRef.current.setFilterModel(newModel);
    } catch (err) {
      console.error("Error setting filter model:", err);
    }
  };

  const applyFilter = (item) => {
    const itemIndex = localItems.findIndex((i) => i.id === item.id);

    if (itemIndex === -1) {
      console.warn("Filter item not found:", item.id);
      return;
    }


    const newItems = [...localItems];
    newItems[itemIndex] = normalizeItem(item);

    setItems(newItems);
    setIsUserInteracting(true);
  };

  const addNewFilter = () => {
    if (!field) return;

    const columnType = columns[field]?.type;
    const defaultOperator = getDefaultOperator(columnType);
    const normalized = normalizeItem({
      columnField: field,
      operatorValue: defaultOperator,
      value: "",
    });

    const newItems = [...localItems, normalized];
    setItems(newItems);

    const fieldItems = newItems.filter((item) => item.columnField === field);
    setExpanded(fieldItems.length - 1);
    setIsUserInteracting(true);
  };

  const clearFilter = () => {
    const newItems = localItems.filter((f) => f.columnField !== field);
    setItems(newItems);
    setExpanded(null);
    setIsUserInteracting(true);
  };

  const clearSingleFilter = (index) => {
    const newItems = localItems.filter((_, i) => i !== index);
    setItems(newItems);
    setExpanded(null);
    setIsUserInteracting(true);
  };

  if (!field) return null;

  const columnType = columns[field]?.type;
  const columnConfig = columns[field];
  const fieldItems = localItems.filter((item) => item.columnField === field);




  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ padding: "5px 0px 0px 15px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FilterAltIcon sx={{ marginRight: "5px" }} />
            <Typography variant="subtitle1" fontSize={14}>
              Filter
            </Typography>
          </Box>
          <IconButton
            aria-label="Add filter"
            color="primary"
            sx={{ color: "black" }}
            component="span"
            onClick={addNewFilter}
          >
            <AddCircleIcon />
          </IconButton>
        </Box>
      </Box>
      <Divider />

      {fieldItems.map((val, fieldIndex) => {
        const actualIndex = localItems.findIndex(
          (item) => item.id === val.id && item.columnField === val.columnField
        );

        const Icon = columnConfig?.props?.icon;
        const isExpanded = expanded === fieldIndex;

        return (
          <Accordion
            key={val.id || fieldIndex}
            expanded={isExpanded}
            disableGutters
            onChange={() => {
              setExpanded(isExpanded ? null : fieldIndex);
            }}
            sx={{ "&.MuiAccordion-root": { margin: 0 } }}
          >
            <AccordionSummary
              sx={{
                "&.MuiAccordionSummary-root": {
                  minHeight: "40px",
                  padding: "0 8px",
                },
                "&.MuiAccordionSummary-content": {
                  margin: "8px 0",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                  {Icon && (
                    <Icon sx={{ marginRight: "5px", fontSize: "20px" }} />
                  )}
                  <Typography variant="subtitle1" fontSize={14}>
                    {columnConfig?.headerName}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ marginLeft: "8px", color: "gray" }}
                  >
                    ({val.operatorValue || "N/A"})
                  </Typography>
                </Box>
                <IconButton
                  aria-label="delete filter"
                  sx={{ color: "black" }}
                  component="span"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    clearSingleFilter(actualIndex);
                  }}
                >
                  <ClearIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Box>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                "&.MuiAccordionDetails-root": {
                  padding: "8px 16px 16px 16px",
                  backgroundColor: "#fafafa",
                },
              }}
            >
              {isExpanded && (
                <>
                  {columnType === "text" ? (
                    <TextFiltersOptions
                      applyFilter={(data) => applyFilter(data)}
                      vals={val}
                    />
                  ) : columnType === "phone" ? (
                    <PhoneFiltersOptions
                      applyFilter={(data) => applyFilter(data)}
                      vals={val}
                    />
                  ) : columnType === "include/exclude/empty" ? (
                    <IncludeWithEmptyFiltersOptions
                      applyFilter={(data) => applyFilter(data)}
                      vals={val}
                      data={columnConfig?.props?.data}
                    />
                  ) : columnType === "include/exclude" ? (
                    <IncludeWithoutEmptyFiltersOptions
                      applyFilter={(data) => applyFilter(data)}
                      vals={val}
                      data={columnConfig?.props?.data}
                    />
                  ) : columnType === "date" ? (
                    <DateFiltersOptions
                      applyFilter={(data) => applyFilter(data)}
                      vals={val}
                      data={columnConfig?.props?.data}
                    />
                  ) : columnType === "price" ? (
                    <PriceFiltersOptions
                      applyFilter={(data) => applyFilter(data)}
                      vals={val}
                    />
                  ) : (
                    <Typography color="error">
                      Unknown filter type: {columnType}
                    </Typography>
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}

      {fieldItems.length === 0 && (
        <Typography
          variant="caption"
          sx={{ padding: "8px 16px", display: "block", color: "gray" }}
        >
          No filters added for this column
        </Typography>
      )}

      <Divider sx={{ margin: "8px 0" }} />
      <Box
        sx={{
          padding: "12px 16px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            "&:hover": { opacity: 0.7 },
          }}
          onClick={() => {
            apiRef.current.setColumnVisibility(field, false);
            setFilterButtonEl(null);
          }}
        >
          <VisibilityIcon sx={{ marginRight: "8px", fontSize: "18px" }} />
          <Typography variant="subtitle2" fontSize={14}>
            Hide Column
          </Typography>
        </Box>

        <Box
          sx={{
            cursor: "pointer",
            "&:hover": { opacity: 0.7 },
          }}
          onClick={() => clearFilter()}
        >
          <Typography variant="subtitle2" fontSize={14}>
            Clear All Filters
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};